import FormGroup from "@mui/material/FormGroup";
import FormHelperText from "@mui/material/FormHelperText";
import { FormContainerCheckbox, FormControlLabelContainer, FormLabelContainer } from "./Styled";


const CheckboxInput = (props) => {
	const {
		id,
		info,
		readOnly,
		value,
		handleChangeCheck,
		mandatory,
		validation,
		validationResult,
		validationMessage,
		options,
		title,
		type,
		handleChangeBooleanCheck,
		isTable
	} = props;

	const isBoolean = (val) => "boolean" === typeof val;

	return (
		<FormContainerCheckbox
			required={mandatory}
			error={validation && isBoolean(validationResult) ? !validationResult : false}
		>
			{
				isTable ? (
					<div className="flex align-center justify-center">
						{value ? (
							<i class="fa-solid fa-check text-lg" style={{ color: '#7bd5e0ff' }}></i>
						) : null}
					</div>
				) : 
				type !== "boolean_field" ?
					<>
						{title && <FormLabelContainer component="legend">{title}</FormLabelContainer>}
						<FormGroup>
							{options?.map((option) => {
								return (
									<FormControlLabelContainer
										key={option}
										control={
											<div className="ckContainer">{option}
												<div className="boxContainer">
													<input type="checkbox"
														disabled={readOnly}
														checked={value?.includes(option)}
														onChange={handleChangeCheck}
														name={option}
														id={id}
													/>
													<span className="checkmark"></span>
													<div className="forHoverEffect"></div>
												</div>
											</div>
										}
										label=""
									/>
								);
							})}
						</FormGroup>
					</>
					:
					<FormGroup>
						<FormControlLabelContainer
							control={
								<div className="ckContainer">
									<div className="boxContainer">
										<input
											type="checkbox"
											disabled={readOnly}
											checked={value || false}
											onChange={handleChangeBooleanCheck}
											name={id}
											id={id}
										/>
										<span className="checkmark"></span>
									</div>
								</div>
							}
							label={title} // Aligns the title with the checkbox
						/>
					</FormGroup>
			}
			{!props.inline && (
				<FormHelperText>
					{isBoolean(validationResult) && !validationResult
						? validationMessage
						: info}

				</FormHelperText>
			)}
		</FormContainerCheckbox>
	);
};

export default CheckboxInput;
